var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9091 4.18262H4.42424C3.78129 4.18262 3.16468 4.43803 2.71004 4.89266C2.25541 5.34729 2 5.96391 2 6.60686V23.5766C2 24.2195 2.25541 24.8361 2.71004 25.2908C3.16468 25.7454 3.78129 26.0008 4.42424 26.0008H21.3939C22.0369 26.0008 22.6535 25.7454 23.1081 25.2908C23.5628 24.8361 23.8182 24.2195 23.8182 23.5766V15.0917",
    stroke: "#040015",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5236 2.76798C22.0153 2.27625 22.6823 2 23.3777 2C24.0731 2 24.74 2.27625 25.2317 2.76798C25.7235 3.25971 25.9997 3.92663 25.9997 4.62204C25.9997 5.31745 25.7235 5.98438 25.2317 6.4761L13.4893 18.2185L8.54517 19.4545L9.78121 14.5104L21.5236 2.76798Z",
    stroke: "#040015",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.35ed925fbf618943d343b793d78915a6.svg";
export { ForwardRef as ReactComponent };